import request from "../../utils/request";

//获取发布商品需要的输入模型
export const getPublishProductForInputGameModel = (data)=>{
   return  request({
        method:'POST',
        url:'/game/getWebPublishProductForInputGameModel',
        data
    })
}

//上传发布商品时的截图
export const publishProductUploadImage = (data)=>{
    return  request({
         method:'POST',
         url:'/game/publishProductUploadImage',
         headers: {
            'Content-Type': 'multipart/form-data', // 重要：设置 Content-Type
         }, 
         data
     })
 }
 
 //删除发布商品时的截图
 export const deletePublishProductScreenshot = (data)=>{
    return  request({
         method:'POST',
         url:'/game/deletePublishProductScreenshot',
         data
     })
 }

  //删除发布商品时的截图
 export const webPublishProduct = (data)=>{
    return  request({
         method:'POST',
         url:'/game/webPublishProduct',
         data
     })
 }